import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";

import reportWebVitals from "./reportWebVitals";
import Under from "./Under";
import "bootstrap/dist/css/bootstrap.min.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Datos from "./datos";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Under />,
  },
  {
    path: "/datos",
    element: <Datos />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
